module.exports = __webpack_public_path__ + "static/media/project-example.3a7a8933.png";